export enum SensorModeType {
    SINGLE= 'SINGLE', PAIR = 'PAIR', TRIO = 'TRIO'
}
